const state = {
  title: '',
  icons: []
}

const getters = {
  getTitle: state => state.title,
  getIcons: state => {
    /* let repArr = []
    for (let iconGroup of state.icons) {
      for (let icon of Object.values(iconGroup)) {
        repArr.push(...icon)
      }
    }
    return repArr */
    return state.icons
  }
}

const actions = {
  'ADD_ICON_TOOLBAR': ({ state }, icons) => {
    // state.icons = []
    // console.log('toolbar', toolbar)
    if (toolbar) {
      // let id = Math.random().toString(36).substr(2, 9)
      // state.icons.push({ [id]: icons })
      // return id
      state.icons = [...icons]
    }
  }
}

const mutations = {
  'UPDATE_TITLE': (state, title) => {
    state.title = title
  },
  'UPDATE_ICONS': (state, icons) => {
    state.icons = [...icons]
  },
  'REMOVE_ICON_TOOLBAR': (state/*, id */) => {
    /* for (let k in state.icons) {
      if (state.icons[k][id]) {
        delete state.icons[k][id]
      }
    } */
    state.icons = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
